import { createTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core";

export const muiTheme = createTheme({
  props: {
    MuiTextField: {
      autoFocus: true,
      variant: "outlined",
      inputProps: {
        autoComplete: "off",
      },
    },
  },
  overrides: {
    MuiTextField: {
      root: {
        "& > *": {
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
          paddingBottom: "0px",
          maxWidth: "366px",
          maxHeight: "42px",
          marginBottom: "15px",
          "@media (max-height: 700px)": {
            maxHeight: "32px",
            fontSize: "13px",
            marginBottom: "4px",
          },
        },
        "&$selected": {
          backgroundColor: "red",
          "&:hover": {
            backgroundColor: "green",
          },
          "&:focus": {
            borderColor: "brown",
          },
          "&:before": {
            borderColor: "orange",
          },
          "&:after": {
            borderColor: "green",
          },
        },
      },
    },
    MuiInputLabel: {
      root: {
        display: "flex",
        marginTop: "-5px",
        "@media (max-height: 700px)": {
          fontSize: "12px",
          marginTop: "-10px",
        },
      },
    },
    MuiMenuItem: {
      root: {
        "@media (max-height: 700px)": {
          fontSize: "12px",
        },
      },
    },
  },
});

export const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    minWidth: "366px",
    maxWidth: "366px",
    paddingTop: "15px",
    "@media (max-height: 700px)": {
      minWidth: "230px",
      maxWidth: "230px",
    },
  }),
}));
